export default __webpack_public_path__ + "static/media/sub-topic-model-03.05af0961.glb";